import { MapPin, Calendar, CheckCircle2, Truck } from "lucide-react";

const STEPS = [
  { icon: MapPin, title: "Indica tu dirección", text: "Localiza tu domicilio en el mapa y describe lo que necesitas recoger." },
  { icon: Calendar, title: "Elige fecha", text: "Selecciona el día disponible según el servicio: enseres o poda." },
  { icon: CheckCircle2, title: "Recibe tu ticket", text: "Confirmamos tu solicitud al instante con un código de seguimiento." },
  { icon: Truck, title: "Día de recogida", text: "Deja los enseres o restos junto a la isla de contenedores indicada y nuestro equipo los recogerá." },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-municipal font-semibold text-sm uppercase tracking-widest">Proceso</span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-municipal mt-3">Cómo funciona</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {STEPS.map((step, idx) => (
            <div key={idx} className="relative text-center px-4" data-testid={`step-${idx}`}>
              <div className="w-16 h-16 mx-auto rounded-full bg-municipal/10 flex items-center justify-center mb-5 relative">
                <step.icon className="w-7 h-7 text-municipal" />
                <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-dorado text-white text-xs font-bold flex items-center justify-center">
                  {idx + 1}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-lg text-municipal mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
